<template>
  <div>
    <div
      class="relative max-w-xl mx-auto bg-white rounded-t-2xl rounded-br-2xl border-4 border-vectric sm:px-6 lg:px-8 py-16 px-4 "
    >
      <div class="text-center">
        <h2
          class="text-3xl leading-9 font-extrabold tracking-wide text-darkBlue sm:text-4xl sm:leading-10 font-open-sans"
        >
          Thanks for Registering
        </h2>
        <p class="mt-4 text-lg leading-6 text-gray-500">
          By registering you can take part in the interactive parts of our
          Worldwide User Group Meeting. We first need to know how you'd like to
          be seen to other participants
        </p>
        <div
          class="mt-4 text-lg leading-6 text-red border border-red p-2"
          v-if="signInError"
        >
          {{ signInError }}
        </div>
        <div
          class="mt-4 text-lg leading-6 text-red border border-red p-2"
          v-if="form.validationErrors.length > 0"
        >
          <div v-for="(err, idx) in form.validationErrors" :key="idx">
            {{ err }}
          </div>
        </div>
      </div>
      <div class="mt-12">
        <form v-on:submit.prevent="completeRegistration" method="POST">
          <div>
            <label
              for="display_name"
              class="block  font-medium leading-5 text-gray-700"
              >Display Name</label
            >
            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                v-model="form.userDisplay"
                id="display_name"
                placeholder="John Smith"
                class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
              />
            </div>
          </div>
          <div class="mt-6">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <span
                  @click="form.agreeTerms = !form.agreeTerms"
                  role="checkbox"
                  tabindex="0"
                  aria-checked="false"
                  class="bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline"
                  :class="{ 'bg-gray-600': form.agreeTerms }"
                >
                  <!-- On: "translate-x-5", Off: "translate-x-0" -->
                  <span
                    aria-hidden="true"
                    class="translate-x-0 inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200"
                    :class="{
                      'translate-x-5': form.agreeTerms,
                      'translate-x-0': !form.agreeTerms
                    }"
                  ></span>
                </span>
              </div>
              <div class="ml-3">
                <p class="text-base leading-6 text-gray-500">
                  By selecting this, you agree to the
                  <router-link to="/privacy">
                    <a href="#" class="font-medium text-gray-700 underline"
                      >Privacy Policy</a
                    >.
                  </router-link>
                </p>
              </div>
            </div>
          </div>
          <div class="mt-6">
            <span class="w-full inline-flex rounded-md shadow-sm">
              <button type="submit" class="standard-btn w-full">
                Sign Me up
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "../utils/firebase";

export default {
  name: "PostLoginRegistrationForm",
  data() {
    return {
      signInError: null,
      form: {
        validationErrors: [],
        userDisplay: "",
        agreeTerms: false
      }
    };
  },
  methods: {
    completeRegistration() {
      this.form.validationErrors = [];
      if (!this.form.agreeTerms) {
        this.form.validationErrors.push(
          "You must agree to the privacy policy."
        );
        return false;
      }
      if (this.form.userDisplay.trim().length === 0) {
        this.form.validationErrors.push("Please provide a display name");
        return false;
      }

      if (!auth.currentUser) {
        this.form.validationErrors.push("Completion only valid if logged in");
        return false;
      }

      // Check for someone with this display name

      // OK now do the firebase validation
      auth.currentUser
        .updateProfile({
          displayName: this.form.userDisplay
        })
        .then(() => {
          this.$store.dispatch("setUser", auth.currentUser);
        })
        .then(() => {
          this.$router.replace({ name: "Home" });
        })
        .catch(error => {
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
          this.signInError = error.code;
        });
    }
  }
};
</script>

<style scoped></style>
